module.exports = __webpack_public_path__ + "img/ChartBerechnen.0dd8f092.png";